<div
    class="drop-zone"
    [class.drag-over]="isDragging()"
    [class.has-image]="selectedFile()"
    (click)="fileInput.click()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <input
      #fileInput
      type="file"
      accept="image/*"
      hidden
      (change)="onFileSelected($event)"
    />

    @if (selectedFile()) {
      <div class="preview">
        <img [src]="previewUrl()" alt="Preview" />
        <div class="overlay">
          <span>Replace image</span>
        </div>
      </div>
    } @else {
      <div class="placeholder">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <circle cx="8.5" cy="8.5" r="1.5"/>
          <path d="m21 15-5-5L5 21"/>
        </svg>
        <p class="label">Drop an image here</p>
        <p class="sublabel">or click to browse</p>
      </div>
    }
</div>  